<template>
    <div id="introduction">
        <p v-html="detail.content"></p>
    </div>
</template>

<script>
    export default {
        name: "Introduction",
        data(){
            return{
                detail:''
            }
        },
        methods:{
            getNav(){
                this.$axios({
                    url:'/navigation/navigationbar',
                    method:'get'
                }).then(res=>{
                    if (res.data.code === 200){
                        this.detail = res.data.msg.navigationBars[1].navigationSubmenus[0];
                    }
                })
            },
        },
        created() {
            this.getNav();
        }
    }
</script>

<style scoped lang="less">
#introduction{
    margin-top: 30px;
    color: #181818;
    font-size: 14px;
    line-height: 30px;
    p{
        /*text-indent: 2em;*/
    }
}
</style>
